 import {  HamburgerIcon } from "@chakra-ui/icons";
import {  Button, Flex,IconButton,Image,Menu,MenuButton,MenuDivider,MenuItem,MenuList } from "@chakra-ui/react"
import { useCallback } from "react";
import { Link, useNavigate } from "react-router-dom";
import Logo from '../assets/pro_logo.png'
import Logo2 from '../assets/pro_logo2.png'
import { useCurrentUser } from "../components/user-context";
import {  isCaptin, isLoggedIn, signOut } from "../fetch/auth";
import { ROUTES } from "../routes";

import { FcShipped } from 'react-icons/fc'
import {  MdNewReleases} from 'react-icons/md'
import { FaShippingFast} from 'react-icons/fa'
import { GrInProgress,GrAdd, GrSearch } from 'react-icons/gr'
import { TbTruckReturn } from 'react-icons/tb'

export const NavBar=()=>{
    const { currentUser, refreshCurrentUser } = useCurrentUser();
    const navigate = useNavigate();
    const is_captin=isCaptin();
  const onSignout = useCallback(() => {
    signOut();
    refreshCurrentUser();
    navigate(ROUTES.LANDING);
  }, [navigate, refreshCurrentUser]);
return (
    <Flex bg='gray.50' zIndex={9999}  h={55} position={'sticky'}  top={0} justify={'space-between'} padding={[0,2,0,2]} boxShadow={'xs'}>
        <Flex height={{base:'60%',md:'80%',lg:'100%'}} alignSelf={'center'} marginLeft={2}>
        <Link to={ROUTES.HOME}>
          <Image rounded={10} maxHeight='100%' src={Logo}  />
          </Link>
          </Flex>
       {isLoggedIn() &&
          <Flex alignItems={'center'} margin={2} dir="rtl">
            <Menu>
             
              <MenuButton
                as={IconButton}
                aria-label='Options'
                icon={<HamburgerIcon />}
                variant='outline'
                />
              
              <MenuList overflowX="auto" maxHeight="90vh">               
              {/*<MenuGroup color={'blue.600'} textAlign={'center'} title='برو إكسبريس'>*/}
                <MenuItem justifyContent={'center'} onClick={()=>{navigate(ROUTES.HOME)}}>
                 <Image maxHeight={'40px'} src={Logo2}></Image>
               </MenuItem>
               
              <MenuItem isDisabled={is_captin} icon={<GrAdd />} onClick={()=>{navigate(ROUTES.NEW_SHIPP)}}>طرد جديد</MenuItem>
              <MenuItem icon={<GrSearch/>} onClick={()=>{navigate(ROUTES.VIEW_SHIPP)}}>موقف الطرد</MenuItem>
              <MenuItem isDisabled={is_captin} icon={<MdNewReleases/>} onClick={()=>{navigate(ROUTES.LIST_SHIPP('0'))}}>الجديدة</MenuItem>
              <MenuItem isDisabled={is_captin} icon={<GrInProgress/>} onClick={()=>{navigate(ROUTES.LIST_SHIPP('1'))}}>قيد التنفيذ</MenuItem>
              <MenuItem icon={<FaShippingFast/>} onClick={()=>{navigate(ROUTES.LIST_SHIPP('2'))}}>مع الكابتن</MenuItem>
              <MenuItem icon={<TbTruckReturn/>} onClick={()=>{navigate(ROUTES.LIST_SHIPP('3'))}}>مرتجع</MenuItem>
              <MenuItem icon={<FcShipped/>} onClick={()=>{navigate(ROUTES.LIST_SHIPP('4'))}}>منتهي</MenuItem>    

               <MenuDivider />
                <MenuItem onClick={()=>{navigate(ROUTES.USER_PROFILE)}}>{currentUser?.email}</MenuItem>
                <MenuItem onClick={onSignout}>تسجيل الخروج</MenuItem>
             
              </MenuList>
          
            </Menu>
           
          </Flex>
          }
           {!isLoggedIn() &&
            <Flex  display='flex' gap={4} align='center' padding={1}>
           <Link to={ROUTES.SIGN_IN}>
           <Button colorScheme='blue' margin='auto' size={'sm'}>Sign in</Button> 
           </Link>
           <Link to={ROUTES.SIGN_UP}>
            <Button bg='red.400' color={'white'} margin='auto' size={'sm'}>Sign up</Button>
            </Link>
            </Flex>
           }


           {/*!isLoggedIn() ?  <Flex display='flex' gap={4}>
           <Link to={ROUTES.SIGN_IN}>
           <Button colorScheme='blue' margin='auto'>Sign in</Button> 
           </Link>
           <Link to={ROUTES.SIGN_UP}>
            <Button bg='red.400' color={'white'} margin='auto'>Sign up</Button>
            </Link>
            </Flex>
             :<Flex display='flex' gap={4}>
            <Text margin={'auto'}>{currentUser?.email}</Text>      
            <Button colorScheme='blue' margin='auto' onClick={onSignout}>Sign out</Button> 
            </Flex>*/}
        
    </Flex>  
   
);
}; 